import { useGeneralStore } from "%/stores/general-store";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { useFanPublicationStore } from "%/stores/fan-publication-store";

export const useSubscriptionBillingHistoryFeedStore = defineSmartFeedPiniaStore(
  "subscription-billing-history-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      metadata: {
        fanOrgId: useGeneralStore().orgId,
        publicationId: useFanPublicationStore().publicationId,
        userId: useGeneralStore().userId,
      },
      tableFields: [
        { key: "datePaid", label: "Date Billed", width: "15%" },
        { key: "amount", label: "Amount", width: "15%" },
        { key: "publicationName", label: "Publication", width: "20%" },
        { key: "description", label: "Description", width: "35%" },
      ],
    }),
    getters: {
      feedUrl() {
        return `/subscription/${this.metadata.fanOrgId}/${this.metadata.userId}/billing/smart-feed`;
      },
    },
  },
);
